import $ from 'jquery';
import 'jquery-validation';
import MultipleSelect from './MultipleSelect';
import FormWatcher from './form-watcher';

// form-error-summary
// close form error when clicking on the close icon
$(".form-error-summary").on("click", ".close-icon", function () {
    $(this).closest(".form-error-summary").hide();
});

// validation
// simple form validation on submit
// <form novalidate>
$.validator.setDefaults({
    ignore: ".validation-ignore *",
    errorElement: 'span',
    errorPlacement: function (error, element) {
        // prepare error element
        error.addClass('invalid-feedback');

        // get validation group
        // if element belongs to .validation-group then display validation group message
        let validationMessageContainer = $(element).closest(".validation-group");
        // else display inline error message

        if (validationMessageContainer.length <= 0) {
            validationMessageContainer = element.parent();
        }
        let errorElement = validationMessageContainer.children(".invalid-feedback");

        // if feedback is not exist then add a default one
        if (errorElement.length <= 0) {
            validationMessageContainer.append(error);
        } else if (errorElement.text().length <= 0) {
            // add default message if feedback exist but empty
            errorElement.text(error.text());
        }
    },
    highlight: function (element, errorClass, validClass) {
        // get validation group
        // if element belongs to .validation-group then display validation group message
        let validationMessageContainer = $(element).closest(".validation-group");
        // else display inline error message

        if (validationMessageContainer.length > 0) {
            validationMessageContainer.addClass('is-invalid');
        }
        else {
            // add invalid class to input
            $(element).addClass('is-invalid');
        }
    },
    unhighlight: function (element, errorClass, validClass) {
        // get validation group
        // if element belongs to .validation-group then display validation group message
        let validationMessageContainer = $(element).closest(".validation-group");
        // else display inline error message

        if (validationMessageContainer.length > 0) {
            // remove invalid class to input
            validationMessageContainer.removeClass('is-invalid');
        } else {
            // remove invalid class to input
            $(element).removeClass('is-invalid');
        }
    }
});


// catch custom validation event from inside of the form
$('form').on('validate', 'input', function (e) {
    $("form").validate().element(e.target);
});


$(document).on('submit', 'form', function (e) {
    if (!$(this).valid()) {
        e.preventDefault();
    }
});

// submit form on clicking on button
$(document).on("click", "[js-form-submit]", function (e) {
    const formTarget = $(this).attr("js-form-submit");
    if (!!formTarget) {
        $(formTarget).submit();
    } else {
        $(this).closest("form").submit();
    }
});

// reset form when click on [js-form-reset-trigger]
$(document).on('click', '[js-form-reset-trigger]', function (e) {
    e.preventDefault();
    // clear all field and submit
    const form = $(this).closest("form");
    form.find("input").val('');
    form.find("select").val('');
    form.find("textarea").val('');
    form.submit();
});

// multiple select
[].slice.call(document.querySelectorAll('.multiple-select')).forEach((element: HTMLSelectElement) => {
    new MultipleSelect(element).init();
});

// select input: empty state
// JavaScript toggles the grey color of the control when the placeholder is selected
$("select:has(option[disabled]:first-child)").on('change', function () {
    $(this).toggleClass("empty", $.inArray($(this).val(), ['', null]) >= 0);
}).trigger('change');

// input with clear append
$(".input-group-merge-append[data-clear]").click(function () {
    const input = $(this).siblings('input').not("[type='hidden']");
    input.val("");
});


// form watcher
// allow submit if form valid
// disable button and add tooltip if invalid
document.querySelectorAll<HTMLFormElement>("[js-form-watcher]").forEach(form => {
    // submit button
    form.querySelectorAll<HTMLElement>('[type="submit"]').forEach(submitBtn => {
        // disable button first
        addButtonTooltip(submitBtn, true);


        const watcher = new FormWatcher(form);
        watcher.init();

        form.addEventListener("update", (e: CustomEvent) => {
            if (!!e.detail.state) {
                // enable button
                addButtonTooltip(submitBtn, false);
                // hide error message
                //form.querySelector(".form-error-summary")?.remove();
            } else {
                // disable button
                addButtonTooltip(submitBtn, true, e.detail.invalid.join(' '));
            }
        });
    });
});
function addButtonTooltip(button: HTMLElement, disabled: boolean, tooltip: string = "") {
    if (!!disabled) {
        button.setAttribute("disabled", "true");
    } else {
        button.removeAttribute("disabled");
    }

    // add tooltip to parent
    const tooltipTarget = $(button).parent();
    // get custom tooltip
    let customTooltip = $(button).data('disabled-tooltip');
    if (!disabled) {
        customTooltip = $(button).data('tooltip');
    }
    // remove
    tooltipTarget.tooltip('dispose');
    // get latest tooltip
    if (!!customTooltip) {
        tooltip = customTooltip;
    }
    // add
    tooltipTarget.tooltip({
        title: tooltip
    });
}
export default undefined;